module.exports = __webpack_public_path__ + "img/rank_star_4.4eb38643.png";